import cn from 'classnames';
import { FC } from 'react';

import { ICatalogItem } from '../../../../shared/types/card';
import { CustomButton } from '../../../Button';
import { Icon } from '../../../Icon';
import { OurAddress } from '../../../OutAddress';

import styles from './CardInformation.module.sass';

interface ICardInformation {
  item: ICatalogItem;
  handleShowAddress: () => void;
  showAddress?: boolean;
}
const CardInformation: FC<ICardInformation> = ({
  item,
  handleShowAddress,
  showAddress = true,
}) => {
  
  //Получить адрес
  const getAddress = ()=> {
    let address = "";
    let default_address = "ул. Дальзаводская 4, пав. №101";

    if(item == null){
      address = default_address;
    }else{
      if(item.vendor.floor == "" && item.vendor.pavilion == ""){
        address = default_address;
      }else{
        address = "ул. Дальзаводская 4";
        if(item.vendor.floor != "") address += ", этаж " + item.vendor.floor;
        if(item.vendor.pavilion != "") address += ", пав. №" + item.vendor.pavilion;
        if(item.vendor.phone != "") address += ", тел. " + item.vendor.phone;
      }
    }

    return address;
  }

  return (
    <div className={styles.vendor}>
      <div className={styles.title}>
        <Icon variant="shop" />
        {item?.vendor?.title}
      </div>
      <div
        className={cn(styles.address, {
          [styles.outlined]: showAddress,
        })}
        onClick={handleShowAddress}
      >
        <Icon variant="location" />
        <p>Показать адрес</p>
      </div>

      <div className={styles.divider} />
      <div className={styles.payment}>
        <div>
          <Icon variant="creditCard" />
          Безналичный расчет
        </div>
        <div>
          <Icon variant="wallet" /> Наличный расчет
        </div>
      </div>
      <div className={styles.guarantee}>
        <Icon variant="guarantee" />
        Гарантия возврата денег, если товар не подойдёт
      </div>
      <CustomButton variant="blue">Написать продавцу</CustomButton>
      {showAddress && (
        <OurAddress 
        open={showAddress} 
        handleClose={handleShowAddress}
        address={getAddress()}>
          <iframe
            src="https://yandex.ru/map-widget/v1/?um=constructor%3A685160ebcbd08cdd6fced4352a2da0677b7dad84ab9f5e22966bb3ba8af08660&amp;source=constructor"
            width="100%"
            height="500"
            frameBorder="0"
          />
        </OurAddress>
      )}
    </div>
  );
};

export default CardInformation;
